import React from "react"
import ReviewStyle from "./ReviewStyle.module.styl"
import Image from "gatsby-image"
import { Link } from "gatsby"

const Review = ({ image, name, description, to }) => {
  return (
    <Link to={`/${to}/`} className={ReviewStyle.holder}>
      <div className={ReviewStyle.image_holder}>
        <Image alt="review-image" className={ReviewStyle.image} fluid={image} />
      </div>
      <p className={ReviewStyle.description}>{description}</p>
      <p className={ReviewStyle.name}>{name}</p>
    </Link>
  )
}

export default Review
